import React, { useEffect, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import Swal from "sweetalert2";
import {
    Box,
    Button,
    TextField,
    Typography,
    Container,
    Paper,
    InputAdornment,
    IconButton,
    Avatar,
    Fade,
} from "@mui/material";
import {
    Email,
    Lock,
    Visibility,
    VisibilityOff,
} from "@mui/icons-material";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("user_info")) {
            // window.location.href = "/table-orders";
        }
    }, []);

    const Toast = Swal.mixin({
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
    });

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            Toast.fire({ icon: "error", title: "Enter Email & Password" });
            return;
        }

        try {
            const userCredential = await signInWithEmailAndPassword(
                auth,
                email,
                password
            );
            if (userCredential.user) {
                Toast.fire({ icon: "success", title: "Welcome Back 👋" });
                window.location.href = "/table-orders";
            }
        } catch (error) {
            Toast.fire({ icon: "error", title: "Invalid Credentials" });
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                    "linear-gradient(135deg, rgb(15, 39, 36), #057975, #2c5364)",
            }}
        >
            <Container maxWidth="xs">
                <Fade in timeout={800}>
                    <Paper
                        elevation={12}
                        sx={{
                            p: 5,
                            borderRadius: 5,
                            backdropFilter: "blur(20px)",
                            background: "rgba(255,255,255,0.08)",
                            border: "1px solid rgba(255,255,255,0.2)",
                            color: "#fff",
                        }}
                    >
                        <Box display="flex" justifyContent="center">
                            <Avatar
                                src="/logo.png"
                                alt="Reszio"
                                variant="square"   // 👈 important
                                sx={{
                                    width: 100,
                                    height: 100,
                                    mb: 2,
                                    borderRadius: 3,   // 0 = sharp square, 3 = slightly rounded
                                    boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
                                }}
                            />
                        </Box>

                        {/* Title */}
                        <Typography
                            variant="h4"
                            align="center"
                            sx={{ fontWeight: "bold", mb: 1 }}
                        >
                            Welcome Back
                        </Typography>

                        <Typography
                            variant="body2"
                            align="center"
                            sx={{ mb: 4, opacity: 0.8 }}
                        >
                            Login to manage your restaurant
                        </Typography>

                        {/* Form */}
                        <Box component="form" onSubmit={handleLogin}>
                            <TextField
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                label="Email Address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Email sx={{ color: "#fff" }} />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    input: { color: "#fff" },
                                    label: { color: "#ccc" },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "rgba(255,255,255,0.4)",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#fff",
                                        },
                                    },
                                }}
                            />

                            <TextField
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                label="Password"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Lock sx={{ color: "#fff" }} />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setShowPassword(!showPassword)}
                                                sx={{ color: "#fff" }}
                                            >
                                                {showPassword ? (
                                                    <VisibilityOff />
                                                ) : (
                                                    <Visibility />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    input: { color: "#fff" },
                                    label: { color: "#ccc" },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "rgba(255,255,255,0.4)",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#fff",
                                        },
                                    },
                                }}
                            />

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{
                                    mt: 4,
                                    py: 1.5,
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    borderRadius: 3,
                                    background:
                                        "linear-gradient(90deg, #ff512f, #dd2476)",
                                    boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                    "&:hover": {
                                        background:
                                            "linear-gradient(90deg, #dd2476, #ff512f)",
                                    },
                                }}
                            >
                                Sign In
                            </Button>
                        </Box>
                    </Paper>
                </Fade>
            </Container>
        </Box>
    );
}

export default Login;